import React from "react"
import BigMenu from "./BigMenu"
import { menuData } from "./menuData"
import { BigMenuItemsContainer } from "./style"

function MenuDas({ user }) {

	const menuBase = user? menuData.filter(menu=>menu.roles.includes(user?.admin_role)):menuData

	return (
		<BigMenuItemsContainer>
			{menuBase?.map((menu, i) => (
				<BigMenu
					link={menu.link}
					text={menu.text}
					key={i}
					icon={menu.icon}
				/>
			))}
		</BigMenuItemsContainer>
	)
}

export default MenuDas
